import { removeAccents } from "./removeAccents";

export let prepareSearch = (string) => {
  return removeAccents(string.toUpperCase());
};
